import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import CustomEditor from '../../common/CustomEditor'

import { Col, Row } from 'reactstrap'
import CustomModal, { useModal } from '../../common/CustomModal/CustomModal'
import { AddAttachment } from '../../common/FileAttachment/AddAttachment'
import { useFileAttachments } from '../../hooks/useFileAttachments'
import { editSharedNoteData, editTaskData } from './Redux/taskActions'

const CompleteTaskContactInfo = ({ note, editTaskData, editSharedNoteData }) => {
  const handleChangeNote = (e) => {
    editTaskData('description', e.htmlValue)
    editSharedNoteData('note', e.htmlValue)
    editSharedNoteData('oldCrmNote', e.textValue.replace(/<[^>]*>/g, '').replace(/\r?\n/g, '\\n'))
  }

  const { attachments, isMaxFilesExceeded, onUploadDocuments: onAttachmentUpload, List } = useFileAttachments()
  const { isModalOpen: isAddAttachmentModalOpen, toggleModal: toggleAddAttachmentModal } = useModal()

  useEffect(() => {
    editTaskData('attachments', attachments)
  }, [attachments])

  const onUploadDocuments = (data) => {
    toggleAddAttachmentModal()
    onAttachmentUpload(data)
  }

  return (
    <>
      <CustomModal
        isOpen={isAddAttachmentModalOpen}
        toggle={toggleAddAttachmentModal}
        headerText={`Add Attachment`}
        showCloseButton
      >
        <AddAttachment multiple onUploadDocuments={onUploadDocuments} />
      </CustomModal>

      <CustomEditor
        addAttachmentClick={toggleAddAttachmentModal}
        disableAttachmentButton={isMaxFilesExceeded}
        name='note'
        onChange={handleChangeNote}
        value={note}
        height='200px'
        customStyle={{ backgroundColor: 'none' }}
      />

      <Row>
        <Col>{List}</Col>
      </Row>
    </>
  )
}

CompleteTaskContactInfo.propTypes = {
  note: PropTypes.string,
  editTaskData: PropTypes.func.isRequired,
}

CompleteTaskContactInfo.defaultProps = {
  note: '',
}

const mapStateToProps = (state) => {
  return {
    note: state.Task.data.description,
  }
}

export default connect(mapStateToProps, { editTaskData, editSharedNoteData })(CompleteTaskContactInfo)
